<template>
  <v-card>
    <v-card-title class="align-start">
      <span>Rides Overview</span>
    </v-card-title>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Student</th>
            <th class="text-left">Bus</th>
            <th class="text-left">Taken At</th>
            <th class="text-left">Dropped At</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in studentRides" :key="item.name">
            <td>
              <span v-if="item.student">
                {{ item.student.name }}
              </span>
              <span v-else>-</span>
            </td>
            <td>
              <span v-if="item.ride.bus">
                {{ item.ride.bus.name }}
              </span>
              <span v-else>-</span>
            </td>
            <td>
              <span v-if="item.started_at">
                {{ item.started_at | moment('DD/MM/YYYY') }} -
                {{ item.started_at | moment('HH:mm') }}
              </span>
              <span v-else-if="item.rejected_at">
                Rejected:
                {{ item.rejected_at | moment('DD/MM/YYYY') }} -
                {{ item.rejected_at | moment('HH:mm') }}
              </span>
              <span v-else>-</span>
            </td>
            <td>
              <span v-if="item.finished_at">
                {{ item.finished_at | moment('DD/MM/YYYY') }} -
                {{ item.finished_at | moment('HH:mm') }}
              </span>
              <span v-else>-</span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  props: {
    studentRides: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {},
  watch: {
    studentRides: function (newValue, oldValue) {
      // console.log('watch', newValue);
    },
  },
};
</script>

<style lang="scss" scoped></style>
